<template>
  <div class="clients management-page card-2">
    <span class="title">Key Entry</span>
    <div class="mt-1 position-relative">
      <div class="d-flex align-items-center">
        <vue-json-pretty :data="componentLoadText" class="pretty" />
      </div>

      <div class="d-flex align-items-center">
        <vue-json-pretty :data="kcvLoadText" class="pretty" />
      </div>

      <div class="d-flex align-items-center">
        <vue-json-pretty :data="componentsLoadText" class="pretty" />
      </div>

      <div class="d-flex align-items-center">
        <vue-json-pretty :data="ipekLoadText" class="pretty" />
      </div>

      <div class="form-group mb-2">
        <label for="keyComponent">Enter Key Component:</label>
        <input type="text" class="form-control" id="keyComponent" v-model="keyComponent">
      </div>

      <button class="mt-4 w-100 btn btn-primary" type="submit" :disabled=isSubmitting @click="submitComponent">
        Submit Individual Component
      </button>

      <button class="mt-4 w-100 btn btn-primary" type="submit" :disabled=isSubmittingComponents @click="submitComponents">
        Get ARN
      </button>

      <button class="mt-4 w-100 btn btn-primary" type="submit" :disabled=isSubmittingKCV @click="getKcv">
        Get KCV
      </button>

      <button class="mt-4 w-100 btn btn-primary" type="submit" :disabled=isSubmittingIPEK @click="getIPEK">
        Get IPEK
      </button>
    </div>
  </div>
</template>

<script setup>
// New below
import { computed, ref, onMounted } from 'vue';
import { router } from '@/router';
import { useStore } from 'vuex';
import http from '@/services/http';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import { useToast } from "vue-toastification"
import { PERMISSION_PRIMITIVES, PRIMARY_CLIENT_ID } from '@/config/constants';
import VueJsonPretty from "vue-json-pretty";

onMounted(() => {
});

const toast = useToast()
let toastdefault = { position: "top-center",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false}

// Get user data
const store = useStore();
const defaultClientid = store.getters.defaultClientid;

const userHasPermission = computed(() => (
    !store.getters.merchantHasPermissions ||
    store.getters.grantedPermissions.includes(PERMISSION_PRIMITIVES.PERMISSIONS)
));

if (!userHasPermission.value && defaultClientid !== PRIMARY_CLIENT_ID) {
  toast.error('User does not have permission.');

  router.push('/');
}

const componentLoadText = ref({"data": "Enter a key component or load both components"});
const componentsLoadText = ref({"data": 'Return ARN of Loaded Components'});
const kcvLoadText = ref({"data": "Load KCV"});
const ipekLoadText = ref({"data": "Load IPEK"});
const keyComponent = ref('');
const isSubmitting = ref(false);
const isSubmittingComponents = ref(false);
const isSubmittingIPEK = ref(false);
const isSubmittingKCV = ref(false);


const getKcv = () => {
  isSubmittingKCV.value = true;
  http.get(`/api/key-entry/kcv`)
      .then(response => {
        console.log(response);
        console.log("Key Entry response above");
        if (response.status === 200 && response.data.message) {
          isSubmittingKCV.value = false;
          kcvLoadText.value = response.data.message;
          console.log('Success', response);
          toast.success("Successfully loaded kcv!", toastdefault);
        } else {
          kcvLoadText.value = {
            "error": response.data.message
          }
          isSubmittingKCV.value = false;
          toast.error("Failed to get kcv");
          console.error('Failed to get kcv');
        }
      })
      .catch(error => {
        isSubmittingKCV.value = false;
        toast.error("Failed to get kcv");
        console.error('An error occurred while loading:', error);
      });
};


const getIPEK = () => {
  isSubmittingIPEK.value = true;
  http.post(`/api/remote-key-injection`)
      .then(response => {
        console.log(response);
        console.log("Key Entry response above");
        if (response.status === 200 && response.data.message) {
          isSubmittingIPEK.value = false;
          ipekLoadText.value = response.data.message;
          console.log('Success', response);
          toast.success("Successfully loaded IPEK", toastdefault);
        } else {
          ipekLoadText.value = {
            "error": response.data.message
          }
          isSubmittingIPEK.value = false;
          toast.error("Failed to load key component");
          console.error('Failed to load key component');
        }
      })
      .catch(error => {
        isSubmittingIPEK.value = false;
        toast.error("Failed to load key component");
        console.error('An error occurred while loading:', error);
      });
};

const submitComponent = () => {
  isSubmitting.value = true;
  const data = {
    component: keyComponent.value
  };
  http.post(`/api/key-entry`, data)
      .then(response => {
        console.log(response);
        console.log("Key Entry response above");
        if (response.status === 200 && response.data.message) {
          isSubmitting.value = false;
          componentsLoadText.value = response.data.message;
          console.log('Success', response);
          toast.success("Successfully loaded key component!", toastdefault);
        } else {
          componentsLoadText.value = {
            "error": response.data.message
          }
          isSubmitting.value = false;
          toast.error("Failed to load key component");
          console.error('Failed to load key component');
        }
      })
      .catch(error => {
        isSubmitting.value = false;
        toast.error("Failed to load key component");
        console.error('An error occurred while loading:', error);
      });
};


const submitComponents = () => {
  isSubmittingComponents.value = true;

  http.post(`/api/key-entry/arn`)
      .then(response => {
        console.log(response);
        console.log("Key Entry response above");
        if (response.status === 200 && response.data.message) {
          isSubmittingComponents.value = false;
          componentsLoadText.value = response.data.message;
          console.log('Success', response);
          toast.success("Successfully loaded ARN!", toastdefault);
        } else {
          componentsLoadText.value = {
            "error": response.data.message
          }
          isSubmittingComponents.value = false;
          toast.error("Failed to load ARN");
          console.error('Failed to load ARN');
        }
      })
      .catch(error => {
        isSubmittingComponents.value = false;
        toast.error("Failed to load ARN");
        console.error('An error occurred while loading:', error);
      });
};
</script>

<style lang="scss" scoped>
.title {
  color: #383838;
  font-size: 24px;
}
.loader {
  z-index: 2;
}

.add-user {
  height: 40px;
  padding: 0px 30px;
}

.search-dropdown {
  min-width: 200px;
}

.settings-btn {
  height: 40px;
  padding-top: 7px !important;
  border-radius: 5px !important;

  span {
    vertical-align: middle;
  }
}

.settings-link {
  background-color: var(--c-primary);
  color: var(--c-white);
  border-radius: 5px;
  text-decoration: none;
  height: 40px;
  padding: 7px 12px 6px;
  display: inline-block;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f7a540;
  }
}

.clients {
  .actions {
    height: 100% !important;
  }

  .action-btn {
    line-height: initial;
    width: 30px !important;
    height: 30px !important;
    padding: 2px 1px !important;
    font-size: 14px !important;
    border-radius: 50% !important;

    .icon-container {
      width: auto !important;

      svg {
        width: 19px !important;
      }
    }

    &.success {
      color: #fff !important;
    }
  }
}
.modal-header {
  background-color: #6C757D;
  color: white;
  border-bottom: none;
}

.modal-header .modal-title {
  font-size: 20px;
  font-weight: 700;
}

.modal-body {
  padding: 20px;
}

.modal-body h6 {
  font-size: 18px;
  font-weight: 500;
}

.modal-body p a {
  color: black;
  text-decoration: underline;
}

.modal-body .form-group label {
  font-weight: 600;
}
</style>
